module.exports = __webpack_public_path__ + "img/img5.7f9ae8ee.png";